import { FunctionComponent as FC, useEffect, ComponentProps } from 'react';
import { withStyles, Title } from 'vopay';
import styles from './PageTitle.module.scss';
import { useLayout } from '../../../providers/Layout.provider';
import { useTranslation } from 'react-i18next';

const classes = withStyles(styles);

type TitleProps = ComponentProps<typeof Title>;

const PageTitle: FC<TitleProps> = (props) => {
  const { setPageTitle } = useLayout();
  const { t } = useTranslation('translations');

  useEffect(() => {
    setPageTitle(props.title);

    return () => {
      setPageTitle(null);
    };
  }, [t]);

  return <Title size="lg" bold {...props} className={classes('pageTitleContainer', props.className)} />;
};

export default PageTitle;
